module.exports = __webpack_public_path__ + "img/wz-8-3-1.97d749fb.jpg";